import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import CircularIcon from "./circularIcon";

const CircularIconDepartment = ({
  className = null,
  image = "",
  ...furtherProps
}) => (
  <CircularIcon
    {...furtherProps}
    image={image}
    className={classNames(className, "circular-icon--department")}
  />
);

CircularIconDepartment.propTypes = {
  className: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object]),
};

export default CircularIconDepartment;
